import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import {
  TwitterShareButton,
  FacebookShareButton,
  WhatsappShareButton,
  EmailShareButton
} from 'react-share';
import {
  FacebookIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon
} from 'react-share';
import { Link } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import kingschatLogo from '../../assets/images/kingschat.png';

export default function Share({ open, setOpen, title, url, hastags, id }) {
  function copyToClipboard() {
    navigator.clipboard.writeText(url);
  }

  function copyToClipboard2() {
    navigator.clipboard.writeText(`<iframe src="https://embed.ceflix.org/video/${id}" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`);
  }

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-neutral-900 bg-opacity-50 transition-opacity" />
          </Transition.Child>

          <div className="fixed text-white inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-neutral-800 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full max-w-lg sm:p-6">
                  <div className="flex flex-row justify-between">
                    <h1 className="font-bold text-md">Share</h1>
                    <button type="button" onClick={() => setOpen(!open)}>
                      <XMarkIcon className="h-7 w-7" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="flex flex-col">
                    <div className="mt-4 flex flex-row justify-between gap-4">
                    <div className="flex flex-col justify-center">
                      <Link to='https://kingschat.online/'>
                         <img className="w-[60px] bg-white rounded-full p-2" src={kingschatLogo} />
                          <span className="text-xs">Kingschat</span>
                        </Link>
                      </div>
                      <div className="flex flex-col justify-center">
                        <TwitterShareButton
                          title={title}
                          url={url}
                          className="Demo__some-network__share-button"
                        >
                          <TwitterIcon size={60} round />
                          <span className="text-xs">Twitter</span>
                        </TwitterShareButton>
                      </div>

                      <div className="flex flex-col justify-center">
                        <FacebookShareButton
                          url={'https://peing.net/ja/'}
                          quote={'フェイスブックはタイトルが付けれるようです'}
                          description={'aiueo'}
                          className="Demo__some-network__share-button"
                        >
                          <FacebookIcon size={60} round />
                          <span className="text-xs">Facebook</span>
                        </FacebookShareButton>
                      </div>

                      <div className="flex flex-col justify-center">
                        <WhatsappShareButton title={title} url={url}>
                          <WhatsappIcon size={60} round />
                          <span className="text-xs">WhatsApp</span>
                        </WhatsappShareButton>
                      </div>

                      <div className="flex flex-col justify-center">
                        <EmailShareButton body={url}>
                          <EmailIcon size={60} round />
                          <span className="text-xs">Email</span>
                        </EmailShareButton>
                      </div>
                    </div>
                    <div className="flex flex-row items-center justify-between text-white mt-4 border-1 px-3 py-2 bg-neutral-900 outline outline-1 outline-neutral-600 rounded-xl">
                      <span className="text-sm py-3">{url}</span>
                      <button
                        type="button"
                        className="bg-ceflix-4 bg-red-700 py-2 px-3 font-medium rounded-full text-md text-white"
                        onClick={() => copyToClipboard()}
                      >
                        Copy
                      </button>
                    </div>
                    <span className="text-sm py-3 mt-4 font-bold">Embed Video</span>
                    <div className="flex flex-row items-center justify-between text-white border-1 px-3 py-2 bg-neutral-900 outline outline-1 outline-neutral-600 rounded-xl">
                      <span className="text-sm py-3">{`<iframe src="https://embed.ceflix.org/video/${id}" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`}</span>
                      <button
                        type="button"
                        className="bg-ceflix-4 bg-red-700 py-2 px-3 font-medium rounded-full text-md text-white"
                        onClick={() => copyToClipboard2()}
                      >
                        Copy
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
